import { detectCagnotteProvider } from '../../lib/cagnotte';
import type { CagnotteProvider } from '@shared/types';

const PROVIDER_LABEL: Record<CagnotteProvider, string> = {
  lydia: 'LYDIA',
  helloasso: 'HELLOASSO',
  lepotcommun: 'LE POT COMMUN',
  leetchi: 'LEETCHI',
  gofundme: 'GOFUNDME',
  tipeee: 'TIPEEE',
  kisskissbankbank: 'KISSKISSBANKBANK',
  paypal: 'PAYPAL',
  autre: 'CAGNOTTE',
};

export function CagnotteBadge({ url, label }: { url: string; label: string | null }) {
  const provider = detectCagnotteProvider(url);
  const tag = PROVIDER_LABEL[provider];
  return (
    <span
      className="chat-badge"
      data-provider={provider}
      data-testid="cagnotte-badge"
      title={label ?? tag}
    >
      {tag}
    </span>
  );
}
